module.exports = __webpack_public_path__ + "static/media/logo151.f02e47cd.png";